import { findKey } from 'lodash';


const seaterVariants = '(м|мест\.|местный)';
const smallHouseVariants = '(домик|сруб)';
const comfortVariants = '(удобств\.|удобствами|удобств)';
const standartVariants = '([cс]{1}тандарт[А-я]*)';
const linkedRoomTypeDictionary = {
    'Admiral': [
        /admiral/i,
        /адмиральский/i
    ],
    'Ambassador': [/ambassador/i],
    'Apartment': [
        /apartment/i,
        /^apart/i,
        /\d-х\sкомн\.\sапартаменты(\sс\sкухней)?/i,
        /апартаменты\s\(горы\sморе,\sлайт\)/i,
        /апартаменты\s-\sспо\sгоры-море\sлайт/i,
        new RegExp(`апартаменты\\s\\d-${seaterVariants}\\s\\d-комнатный`, 'i')
    ],
    'Barbados': [/barbados/i],
    'Beach': [/beach/i],
    'Bedroom': [/bedroom/i],
    'Bungalow': [/bungalow/i],
    'Business': [/business/i, /^бизнес$/i],
    'Cabana': [/cabana/i],
    'Capsule': [
        /capsule/i,
        /капсула/i,
        new RegExp(`^капсула\\s\\d-${seaterVariants}$`, 'i')
    ],
    'Chalet': [/chalet/i],
    'City View': [/city view/i, /city\sroom/i, /^city$/i, /^вид на город$/i],
    'Classic': [/classic/i],
    'Club': [/club/i],
    'Comfort': [
        /comfort/i,
        /^комфорт$/i,
        new RegExp(`^${smallHouseVariants}\\sс\\s${comfortVariants}$`, 'i'),
        new RegExp(`^с\\s${comfortVariants}\\.$`, 'i'),
        new RegExp(`^${smallHouseVariants}\\s\\d-${seaterVariants}\\sс\\s${comfortVariants}$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\s${smallHouseVariants}\\sс\\s${comfortVariants}$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\s\\(\\d-${seaterVariants}\\s${smallHouseVariants}\\sс\\s${comfortVariants}\\)$`, 'i'),
    ],
    'Connected': [/connected/i, /^connection/i],
    'Corner': [/corner/i, /угловой/i],
    'Cottage': [/cottage/i],
    'Danai': [/danai/i],
    'Delight': [/^delight/i],
    'Deluxe': [
        /deluxe/i,
        /делюкс/i,
        /представительский сьют/i,
        /^люкс/i,
        new RegExp(`^\\d-${seaterVariants}\\sлюкс`, 'i')
    ],
    'Design': [/design/i],
    'Double': [/double/i],
    'Duplex': [/duplex/i],
    'Econom': [
        new RegExp(`^\\d-${seaterVariants}\\s\\(\\d-${seaterVariants}\\s${smallHouseVariants}\\sбез\\s${comfortVariants}\\)$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\sэконом$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\s${smallHouseVariants}\\sбез\\s${comfortVariants}$`, 'i'),
        new RegExp(`^${smallHouseVariants}\\s\\d-${seaterVariants}\\sбез\\s${comfortVariants}$`, 'i'),
        new RegExp(`^без\\s${comfortVariants}$`, 'i'),
        new RegExp(`^эконом\\s\\d-${seaterVariants}\\sстандарт$`, 'i'),
        new RegExp(`^${standartVariants}\\sэконом\\s\\(горы,?\\sморе,\\sлайт\\)$`, 'i'),
        new RegExp(`^${standartVariants}\\sэконом\\s-\\sспо\\sгоры-море\\sлайт$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\sв\\sблоке,\\sкорпус\\s.+$`, 'i'),
        new RegExp(`^${standartVariants}\\sэконом$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\sдомик\\s\\(ч\\/у\\)`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\s\\d-комн.\\sэконом`, 'i'),
        /комната\sв\sтрех-четырехкомнатном\sномере\sс\sобщим\sс\/у\sкорпус\s.+/i,
        /econom/i,
        /^эконом$/i,
        /eco\sroom/i,
        /\d-комнатный\sэконом/i,
        /^стандарт\sэконом/i,
        /стандарт\sэконом$/i,
        /стандарт-эконом\)$/i,
        /^домик с ч\/у$/i,
        /с\sчастич\.удоб/i
    ],
    'Eden': [/eden/i],
    'Elegance': [/^elegance/i, /elegance\sroom$/i, /^dbl\s\(elegance\sroom\)$/i],
    'Elite': [/elite/i],
    'Executive': [/executive/i],
    'Family': [/family/i, /семейный/i],
    'Famous Class': [/^famous\sclass/i, /^famous-romantic/i],
    'Finata': [/finata/i],
    'Grand': [/grand/i],
    'Guest': [/guest/i],
    'Honeymoon': [/honeymoon/i],
    'Junior': [
        /junior/i,
        /полулюкс/i
    ],
    'Island Hill': [/island/i],
    'King': [/king/i],
    'Lagoon View': [/^lagoon\sview/i],
    'Land View': [/land\sview/i],
    'Large': [/large/i],
    'Light Room': [/^light/i],
    'Maisonette': [/maisonette/i],
    'Maldives': [/maldives/i],
    'Mansard': [/mansard/i],
    'Mini': [/mini/i],
    'Mountain View': [/mountain\sview/i],
    'Ocean': [/ocean/i],
    'One': [/one/i],
    'Palace': [/palace/i],
    'Park Room': [/^park$/i],
    'Parvus': [/parvus/i],
    'Pavillion': [/pavillion/i],
    'Penthouse': [/penthouse/i],
    'Pool Access': [/pool\saccess/i],
    'Pool View': [/^pool\sview/i],
    'Premium': [/premium/i],
    'Presidential': [/presidential/i],
    'Prestige': [/prestige/i],
    'Princess': [/princess/i],
    'Promo': [/Promo/i],
    'Quadruple': [/quadruple/i],
    'Queen': [/queen/i],
    'Residence': [/residence/i],
    'Royal': [/royal/i],
    'Run Of House': [/ROH/i, /run\sof\s(the\s)?house/i],
    'Sea View': [/sea\sside/i, /sea\sview/i, /^sv$/i],
    'Select Room': [/select(\sroom)?/i],
    'Senior': [/senior/i],
    'Single': [/single/i],
    'Small': [/small/i],
    'SPA': [/SPA/i],
    'Standard': [
        /anex\sroom/i,
        /^std/i,
        '-', '–', '_',
        '&nbsp;н.',
        new RegExp(`^\\d-${seaterVariants}\\s${standartVariants}$`, 'i'),
        new RegExp(`^${smallHouseVariants}\\s${standartVariants}$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\s${standartVariants}\\sдабл,\\sкорпус\\s.+$`, 'i'),
        new RegExp(`^${standartVariants}\\sдабл,\\sкорпус\\s.+$`, 'i'),
        new RegExp(`^\\d-${seaterVariants}\\s${standartVariants}$`, 'i'),
        new RegExp(`^${standartVariants}\\s2-${seaterVariants}\\s${standartVariants}\\sdbl$`, 'i'),
        new RegExp(`^${standartVariants}$`, 'i'),
        /standar(t|d)/i,
        /(с|c)танд\./i,
        /^\d\spax$/i,
        /^not\sdefined$/i,
        /стандарт\sулучшенный/i,
    ],
    'Studio': [/studio/i],
    'Suite': [/suite/i],
    'Summer Breeze': [/Summer\sBreeze/],
    'Superior': [/superior/i],
    'Swimming Pool View': [/swimming\spool\sview/i],
    'Terrace': [/terrace/i],
    'Triple': [/triple/i, new RegExp(`^${standartVariants}\\sтрипл$`, 'i')],
    'Twin': [/twin/i],
    'Villa': [/villa/i],
    'Without A/C': [/without\sa\/c/i]
};

export function getLinkedRoomTypeName(originalRoomTypeName: string): string | null {
    const foundKey = findKey(linkedRoomTypeDictionary, (mathes: (RegExp | string)[]) => {
        return mathes.some(pattern => {
            return typeof pattern === 'string'
                ? pattern.toLowerCase() === originalRoomTypeName.toLowerCase()
                : pattern.test(originalRoomTypeName);
        });
    });

    if (!foundKey) {
        return null;
    }

    return foundKey;
}
